import * as React from "react";
import * as cn from "classnames";
import { AdUnitType, campaignCreativesForm } from "@store";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";

const activeInteractions = [
    "360 Panorama + Video",
    "Card Deck",
    "Card Flip",
    "Gyro",
    "Polygon + Video",
    "Overlapping Slider",
    "Page Peel",
    "Scratch Card",
    "Slider",
    "Video",
    "Video Cube",
    "Polygon"
];

export interface AdUnitTypesComponentProps {
    value: string | null;
    onChange: (newValue: string | null) => void;
    adTypes: AdUnitType[];
    events: typeof campaignCreativesForm.types.eventBindings;
}

export class AdUnitTypesComponent extends React.Component<AdUnitTypesComponentProps, any> {
    constructor(props: AdUnitTypesComponentProps) {
        super(props);
    }

    handleOnChange(value: string) {
        this.props.events.fields.adUnitId.onChange(undefined);
        this.props.onChange(value);
    }

    render() {
        const { value, adTypes } = this.props;

        return (
            <>
                <div className="item-inner-wrapper">
                    {adTypes &&
                        adTypes.map((type, index) => (
                            <div key={index} className="device-item" onClick={() => this.handleOnChange(type.name)}>
                                <div className="adUnit-premium-block-wrapper">
                                    <img className="types-icon" src={type.creativeIcon} />
                                    {activeInteractions.some((el: any) => type.interaction.name === el) && (
                                        <PremiumFeatureIcon className="custom-adUnit-premium-icon" status="trial" />
                                    )}
                                </div>
                                <label className={cn("common-radio custom-types-radio")}>
                                    <input
                                        type="radio"
                                        name=""
                                        value={type.name}
                                        id=""
                                        checked={value === type.name}
                                        onChange={() => this.handleOnChange(type.name)}
                                    />
                                    <span className="checkmark" />
                                    <span className="types-title">{type.name}</span>
                                </label>
                            </div>
                        ))}
                </div>
            </>
        );
    }
}
